import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'

export default [
    {
        path: '/find-provider',
        name: 'public.find-provider',
        view: 'public/FindProvider',
    },

    {
        path: `/find-provider/results`,
        name: 'public.find-provider.results',
        view: 'public/FindProviderResults',
        default: { query: { limit: 6 } },
    },
    {
        path: '/support/report-bug',
        name: 'public.support.report-bug',
        view: 'public/Support',
    },
    {
        path: '/referral-leakage-audit',
        name: 'public.referral-leakage-audit',
        view: 'public/ReferralLeakageAudit',
        middlewares: [],
    },
    {
        path: '/records-upload',
        name: 'public.records-upload',
        view: 'public/RecordUploadPortal',
        middlewares: [],
    },
    {
        path: '/records-upload/:token',
        name: 'public.records-upload.token',
        view: 'public/RecordUploadPortal',
        middlewares: [],
    },
    {
        path: '/shared-records/:token',
        name: 'public.shared-records',
        view: 'public/SharedRecords',
        middlewares: [LoadSessionMiddleware],
    },
]
